/**
 * About us page script
 * 
 * @author HammersportMarketing
 */

import "../../sass/about-us.scss";
// import Swiper JS
import Swiper from 'swiper';
// core version + navigation, pagination modules:
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination]);

new Swiper('.about-us-slider',({
    slidesPerView:'auto',
    spaceBetween: 0,
    centeredSlides: true,
    // Optional parameters
    navigation: {
        disabledClass: "swipe-control-disabled",
        nextEl: '.swipe-next',
        prevEl: '.swipe-prev',
    },
    observeParents: true,
    observer: true,
    freeMode: true
}));